import { Bankgarantie as BankgarantieDlEntry } from "../../.generated/forms/formstypes";
import { FieldMap, UiName } from "../../shared/types";
import { target2field } from "../../shared/utils/target-to-field";

export function mapDlTargetToBankgarantieUiField(target: string): UiName | null {
  const map: FieldMap<BankgarantieDlEntry> = {};

  return target2field(map, target);
}
